import { getCurrentCategoryName } from 'facetsHelper';

function updatePressSpecificMeta(intl, searchParams) {
  let metaTitle = intl.formatMessage({ id: 'Press.Title' }, { sitename: process.env.REACT_APP_SITENAME });
  let metaDescription = intl.messages['Press.MetaDescription'] || null;
  let titleTop = intl.formatMessage({ id: 'PressHeader.TitleTop' });
  let titleBottom = intl.messages['PressHeader.TitleBottom'] ? intl.formatMessage({ id: 'PressHeader.TitleBottom' }) : null;

  const categoryName = searchParams.facets ? getCurrentCategoryName(searchParams.facets) : '';

  if (categoryName === 'noticias') {
    metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle.PersonalBranding']
      ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle.PersonalBranding' }, { sitename: process.env.REACT_APP_SITENAME })
      : metaDescription;
    metaTitle = intl.messages['Press.CategoryTitle.Noticias']
      ? intl.formatMessage({ id: 'Press.CategoryTitle.Noticias' }, { sitename: process.env.REACT_APP_SITENAME })
      : metaTitle;
  } else if (categoryName.length > 0) {
    metaTitle = intl.formatMessage({ id: 'Press.CategoryTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: categoryName,
    }) || metaTitle;
    metaDescription = intl.formatMessage({ id: 'Press.MetaDescriptionCategoryDefined' }, {
      category: categoryName,
    }) || metaDescription;
    titleTop = intl.messages['PressHeader.CategoryTitleTop'] ? intl.formatMessage({ id: 'PressHeader.CategoryTitleTop' }, { category: categoryName }) : titleTop;
    titleBottom = intl.messages['PressHeader.CategoryTitleTopBottom'] ? intl.formatMessage({ id: 'PressHeader.CategoryTitleTopBottom' }) : titleBottom;
  }

  return {
    metaTitle,
    metaDescription,
    titleTop,
    titleBottom,
  };
}

export default updatePressSpecificMeta;
